module.exports = __webpack_public_path__ + "img/scene26.6133e79b.gif";